import localeAntd from 'antd/es/locale/en_US'

const messages = {
  'topBar.issuesHistory': 'Issues History',
  'topBar.projectManagement': 'Project Management',
  'topBar.typeToSearch': 'Search...',
  'topBar.findPages': 'Find pages...',
  'topBar.actions': 'Actions',
  'topBar.status': 'Status',
  'topBar.profileMenu.hello': 'Hello',
  'topBar.profileMenu.billingPlan': 'Billing Plan',
  'topBar.profileMenu.role': 'Role',
  'topBar.profileMenu.email': 'Email',
  'topBar.profileMenu.phone': 'Phone',
  'topBar.profileMenu.editProfile': 'Edit Profile',
  'topBar.profileMenu.myProfile': 'My Profile',
  'topBar.profileMenu.changePassword': 'Change Password',
  'topBar.profileMenu.logout': 'Logout',

  // FORM
  'form.changeColor': 'Choose Color',

  // MENU
  'menu.getting_started': 'Getting Started',
  'menu.dashboard': 'Dashboard',
  'menu.customers': 'Customers',
  'menu.integrations': 'Integrations',
  'menu.users': 'Users',
  'menu.billing': 'Billing',
  'menu.billingOverview': 'Overview',
  'menu.invoices': 'Invoices',
  'menu.devices': 'Devices',
  'menu.marketing': 'Marketing',
  'menu.inbox': 'Inbox',
  'menu.digitalSignage': 'Digital Signage',
  'menu.reports': 'Reports',
  'menu.reports.rewardRedeemed': 'Reward Redeemed',
  'menu.reports.giftIssued': 'Gift Issued',
  'menu.reports.giftRedeemed': 'Gift Redeemed',
  'menu.reports.allowanceIssued': 'Allowance Issued',
  'menu.reports.allowanceRedeemed': 'Allowance Redeemed',
  'menu.reports.communicationHistory': 'Communication History',
  'menu.reports.missedCalls': 'Missed Calls',
  'menu.reports.salesOverview': 'Sales Overview',
  'menu.customRewards': 'Custom Rewards',
  'menu.customer_feeback': 'Customer Feedback',
  'menu.settings': 'Settings',
  'menu.collapse_sidebar': 'Collapse sidebar',
  'menu.settings.survey': 'Feedback Questions',
  'menu.settings.website_widget': 'Website Widget',
  'menu.settings.reward_program': 'Reward Program',
  'menu.settings.business_profile': 'Business Profile',
  'menu.settings.brandSetup': 'Brand Setup',
  'menu.settings.reward_card_design': 'Reward Card Design',
  'menu.settings.giftCardDesign': 'Gift Card Design',
  'menu.settings.allowanceCardDesign': 'Allowance Card Design',
  'menu.settings.smartInboxSetup': 'Smart Inbox Setup',

  // AUTH
  'auth.email': 'Email address',
  'auth.password': 'Password',
  'auth.signup.title': 'Sign up',
  'auth.signup.description':
    'Build loyal customers faster and increase sales effortlessly. Launch your Reward Program in minutes!',
  'auth.signup.first_name': 'First Name',
  'auth.signup.last_name': 'Last Name',
  'auth.signup.btn_text': 'Sign up',
  'auth.signup.already_account': 'Already have an account?',
  'auth.signup.login': 'Log in',
  'auth.signup.no_cc': 'No credit card required!',

  'auth.signin.title': 'Log in',
  'auth.signin.signup': 'Sign up',
  'auth.signin.btn_text': 'Log in',
  'auth.signin.forgot_password': 'Forgot password?',
  'auth.signin.description': "Don't have an account?",

  'auth.forgot_password.title': 'Reset Password',
  'auth.forgot_password.description': 'Enter your email to get a password reset link',
  'auth.forgot_password.btn_text': 'Reset Password',
  'auth.forgot_password.remember_text': 'Remember your password?',

  'auth.change_password.title': 'Change Your Password',
  'auth.change_password.btn_text': 'Change Password',

  'auth.verify_account.title': 'Verify Email',
  'auth.verify_account.description':
    'We sent you a code to verify your email. Enter the code you received to your email to login to your account.',
  'auth.verify_account.resend': 'Resend code',
  'auth.verify_account.btn_text': 'Verify Email',

  'auth.reset_password.title': 'Set New Password',
  'auth.reset_password.btn_text': 'Set Password',
}

export default {
  locale: 'en-US',
  localeAntd,
  messages,
}
